import { render, staticRenderFns } from "./OngletKetchup.vue?vue&type=template&id=4c207974"
import script from "./OngletKetchup.vue?vue&type=script&lang=js"
export * from "./OngletKetchup.vue?vue&type=script&lang=js"
import style0 from "./OngletKetchup.vue?vue&type=style&index=0&id=4c207974&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports